module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  /* Each current page renders graphic wigits on this stack of elements.
* Any drop shadow div renders behind and offset from  the canvas.
*/ 
    ; __append("\r\n<!-- a page -->\r\n    <div id=\"page-drop-shadow\" class=\"page-drop-shadow\" tabindex=\"2\" draggable=\"false\"></div>\r\n<div style=\"position: relative;\">\r\n    <canvas id=\"aPageGrid\" style=\"position:absolute; left: 0px; top: 0px; z-index: 1; draggable=\"false\">This browser does not support HTML5 Canvas.</canvas>\r\n    <canvas id=\"aPageSel\"  style=\"position:absolute; left: 0px; top: 0px; z-index: 2; draggable=\"false\">This browser does not support HTML5 Canvas.</canvas>\r\n</div>\r\n<!-- 0..n widgets ->")
  }
  return __output;

}